/**
 * @file The Purchase Album Send Link Component.
 *
 * Allows to sent the user's email the current purchase
 * link they're in.
 *
 * (Semi-long-term hack until we support Consumer Albums Views on Web).
 */

import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import url from 'url';

import getConfig from '../../util/config';

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  user: PropTypes.shape({
    id: PropTypes.string,
  }),
  className: PropTypes.string,
};

const PurchaseAlbumSendPurchaseLink = ({ album, user, className }) => {
  if (!album) {
    return null;
  }

  const config = getConfig();
  const purchaseUrl = `${config.app.baseUrl}/purchase/album/${album.id}`;
  const email = get(user, 'email_address', '');
  const subject = `${album.name} Album's direct access link`;
  const body = `Hello from the Waldo Team!

Feel free to use this link any time you'd like to access your photos:
${purchaseUrl}`;

  const mailTo = url.format({
    pathname: `mailto:${email}`,
    query: {
      subject,
      body,
    },
  });

  return (
    <a href={mailTo} className={className}>
      Send Album&rsquo;s link by email
    </a>
  );
};

PurchaseAlbumSendPurchaseLink.propTypes = propTypes;

export default PurchaseAlbumSendPurchaseLink;
